import { FC, MouseEventHandler } from 'react';
import { MoreActionsMenuItemProps } from 'components/MoreActionsMenu/MoreActionsMenu.types';
import Box from 'yoda-ui/components/Box';
import Divider from 'yoda-ui/components/Divider';
import MenuItem from 'yoda-ui/components/MenuItem';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const MoreActionsMenuItem: FC<MoreActionsMenuItemProps> = ({ closeMenu, menuItemConfig, isLast }) => {
  if (menuItemConfig === null) {
    return null;
  }
  const handleClick: MouseEventHandler<HTMLLIElement> = (e) => {
    closeMenu();
    menuItemConfig.onClick(e);
  };

  return (
    <Box
      minWidth='200px'
    >
      <MenuItem sx={ { padding: YodaSpacing.small } } onClick={ handleClick } >
        <Box>
          { menuItemConfig.label }
        </Box>
      </MenuItem>
      {
        !isLast && (
          <Box marginY={ YodaSpacing.none } >
            <Divider />
          </Box>
        )
      }
    </Box>
  );
};

export default MoreActionsMenuItem;
